import { useState } from "react";

function useLoading() {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  return { isLoading, setIsLoading, showLoader, hideLoader };
}

export default useLoading;
